import React, { ReactNode } from 'react';
import styled from 'styled-components';

const IndicatorContainer = styled.div.withConfig({ componentId: 'sc-qwqhu0-0' })`
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const IndicatorDot = styled.div.withConfig({ componentId: 'sc-qwqhu0-1' })`
  background-color: #28d0b1; /* Substitute with the actual color code for 'bg-positive' */
  border: 1px solid #e9faf7; /* Substitute with the actual color code for 'border-positive-100' */
  width: 6px;
  height: 6px;
  border-radius: 50%;
`;

export function InlineIndicator({ children }: { children: ReactNode }) {
  return (
    <IndicatorContainer>
      <IndicatorDot></IndicatorDot>
      {children}
    </IndicatorContainer>
  );
}
